<template>
  <div class="pa-2">
    <BaseTableSkeletonLoader v-if="isLoadingCourseMarkConfigs"></BaseTableSkeletonLoader>
    <div
      class="d-flex flex-column flex-sm-row px-4 py-6 py-sm-2 align-center"
      v-else-if="!courseMarkConfigs.length"
    >
      <p class="mb-0">Không có cấu hình nào</p>
      <v-btn
        v-if="canEditCourseConfig"
        @click="onClickUpsertCourseMarkConfig()"
        class="ml-0 ml-sm-2 mt-2 mt-sm-0"
        :elevation="0"
        color="primary"
        text
      >
        Tạo cấu hình
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <div class="d-flex mt-2 justify-space-between align-center" v-else>
      <!-- <v-tabs v-model="tabIndex" v-if="!$vuetify.breakpoint.mobile">
        <v-tab v-for="(t, i) in tabs" :key="t.id" style="text-transform: none">
          <div class="d-flex align-center">
            <div style="max-width: 186px" class="flex-fill text-truncate">
              {{ i + 1 }}. {{ t.text }}
            </div>
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-btn text @click.stop="on.click" icon small class="ml-2">
                  <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="px-2" dense>
                <v-list-item @click.stop="onClickEditMarkConfig(t)">
                  <v-list-item-icon>
                    <v-icon small>mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Sửa thông tin</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click.stop="onClickDeleteCourseMarkConfig(t.id)">
                  <v-list-item-icon>
                    <v-icon small>mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Xóa cấu hình </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </v-tab>
      </v-tabs> -->
      <template>
        <div class="d-flex align-center">
          <v-select
            hide-details="auto"
            item-text="title"
            item-value="id"
            :items="courseMarkConfigs"
            label="Chọn cấu hình điểm"
            v-model="activeId"
            class="select-config"
          ></v-select>
          <v-menu v-if="canEditCourseConfig">
            <template v-slot:activator="{ on }">
              <v-btn text @click.stop="on.click" icon small>
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="px-2" dense>
              <v-list-item @click.stop="onClickUpsertCourseMarkConfig(courseMarkConfigData)">
                <v-list-item-icon>
                  <v-icon small>mdi-pencil</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Sửa cấu hình </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click.stop="onClickDeleteConfig">
                <v-list-item-icon>
                  <v-icon small>mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Xóa cấu hình </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <v-btn
        v-if="canEditCourseConfig"
        @click="onClickUpsertCourseMarkConfig()"
        class="ml-2"
        :elevation="0"
        color="primary"
      >
        <span v-if="$vuetify.breakpoint.smAndUp">Thêm cấu hình</span>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
    <BaseDialog
      v-if="addCourseMarkConfigDialog.isOpen"
      :isOpen="addCourseMarkConfigDialog.isOpen"
      :title="addCourseMarkConfigDialog.title"
      @close="addCourseMarkConfigDialog.isOpen = false"
      @cancel="addCourseMarkConfigDialog.onCancel"
      @confirm="addCourseMarkConfigDialog.callback"
    >
      <v-form lazy-validation ref="addCourseMarkConfigDialog" @submit="onSubmitAddCourseMarkConfig">
        <v-card-text>
          <v-text-field
            v-model="addCourseMarkConfigDialog.currentItem.title"
            label="Tiêu đề"
            :rules="[$rules.required]"
            hide-details="auto"
          >
          </v-text-field>
        </v-card-text>
        <input type="submit" class="d-none" />
      </v-form>
    </BaseDialog>
    <CourseTestBuilderTab
      class="mt-4"
      :courseMarkConfig="courseMarkConfigData"
      :course="course"
      v-if="courseMarkConfigData"
    ></CourseTestBuilderTab>
  </div>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog'
import CourseTestBuilderTab from '@/modules/course/test/CourseTestBuilderTab.vue'
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'
import BaseTableSkeletonLoader from '@/components/base/BaseTableSkeletonLoader.vue'

export default {
  components: { CourseTestBuilderTab, BaseTableSkeletonLoader, BaseDialog },
  data() {
    return {
      // tabIndex: 0,
      activeId: '',
      addCourseMarkConfigDialog: {
        currentItem: null,
        isOpen: false,
        title: '',
        valid: true,
        callback: () => {},
        onCancel: () => {
          this.addCourseMarkConfigDialog.isOpen = false
        }
      }
    }
  },
  computed: {
    ...mapState('course', ['courseMarkConfigs', 'isLoadingCourseMarkConfigs', 'courses']),
    ...mapGetters('auth', ['role']),
    canEditCourseConfig() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    },
    course() {
      return this.courses[this.$route.params.id]
    },
    // ...mapState('teacher', ['teachers']),
    // teachersToShow() {
    //   return (Object.values(this.teachers) || []).filter(
    //     teacher =>
    //       !this.searchTeacher ||
    //       teacher.name.toLowerCase().includes(this.searchTeacher) ||
    //       teacher.email.toLowerCase().includes(this.searchTeacher)
    //   )
    // },

    // finalScoreGradingTeacher() {
    //   return (this.course || {}).grading_teachers || []
    // },
    // tabs() {
    //   return this.courseMarkConfigs.map(c => ({
    //     text: c.title,
    //     id: c.id
    //   }))
    // },
    // selectedTab() {
    //   return this.tabs.
    // },
    courseMarkConfigData() {
      if (!this.courseMarkConfigs || !this.activeId) {
        return
      }
      return this.courseMarkConfigs.find(c => c.id === this.activeId)
    },
    componentCourseMark() {
      if (!this.courseMarkConfigData) {
        return []
      }
      return this.courseMarkConfigData.course_marks
    }
    // courseMarkConfigTabs() {
    //   if (!this.courseMarkConfigs || !this.courseMarkConfigs.length) {
    //     return []
    //   }
    //   return this.courseMarkConfigs.map(i => ({
    //     text: i.title,
    //     id: i.id
    //   }))
    // }
  },
  methods: {
    ...mapActions('course', [
      'fetchCourseMarkConfigs',
      'fetchCourse',
      'createCourseMarkConfig',
      'updateCourseMarkConfig',
      'removeCourseMarkConfig'
    ]),
    onClickDeleteConfig() {
      this.$dialog.confirm({
        title: 'Xóa cấu hình điểm',
        text: `Hành động này sẽ xóa toàn bộ điểm và kết quả học tập của các lớp liên quan. Bạn có chắc chắn muốn tiếp tục?`,
        okText: 'Có',
        cancelText: 'Hủy',
        done: (async () => {
          await this.removeCourseMarkConfig({ id: this.activeId })
          this.$alert.success('Cập nhật thành công')
        }).bind(this)
      })
    },

    onClickDeleteCourseMarkConfig(id) {
      if (!id) {
        id = this.courseMarkConfigData.id
      }
      this.$dialog.confirm({
        title: 'Xóa cấu hình môn học',
        text: 'Xóa cấu hình môn học và tất cả các thông tin liên quan (cấu hình điểm, điểm đã chấm)',
        okText: 'Yes',
        cancelText: 'No',
        done: (async () => {
          try {
            await this.removeCourseMarkConfig({ id })
            this.$alert.success('Xóa thành công')
          } catch (error) {
            this.$alert.error('Có lỗi xảy ra')
          } finally {
            this.fetchCourseMarkConfigs(this.$route.params.id)
          }
        }).bind(this)
      })
    },

    onSubmitAddCourseMarkConfig(e) {
      e.preventDefault()
      this.addCourseMarkConfigDialog.callback()
    },
    onClickUpsertCourseMarkConfig(item) {
      this.addCourseMarkConfigDialog.isOpen = true
      this.addCourseMarkConfigDialog.title = item ? 'Sửa cấu hình' : 'Tạo cấu hình'
      this.addCourseMarkConfigDialog.currentItem = item || {
        title: `Cấu hình số ${this.courseMarkConfigs.length + 1} `,
        course: this.$route.params.id
      }
      this.addCourseMarkConfigDialog.callback = (async () => {
        this.addCourseMarkConfigDialog.valid = this.$refs.addCourseMarkConfigDialog.validate()
        if (!this.addCourseMarkConfigDialog.valid) {
          this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
          return
        }

        try {
          if (!this.addCourseMarkConfigDialog.currentItem) {
            return
          }
          if (!item) {
            const { id, ...data } = this.addCourseMarkConfigDialog.currentItem
            const res = await this.createCourseMarkConfig({ data })
            this.$alert.success('Tạo cấu hình thành công')
            this.activeId = res.id
          } else {
            const { id, ...data } = this.addCourseMarkConfigDialog.currentItem
            await this.updateCourseMarkConfig({ id, data })
            this.$alert.success('Tạo cấu hình thành công')
          }
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xảy ra')
          this.fetchCourseMarkConfigs(this.$route.params.id)
        } finally {
          this.addCourseMarkConfigDialog.onCancel()
        }
      }).bind(this)
    }
    // onClickEditMarkConfig(item) {
    //   const data = item
    //     ? this.courseMarkConfigs.find(c => c.id === item.id)
    //     : this.courseMarkConfigData
    //   this.addCourseMarkConfigDialog.isOpen = true
    //   this.addCourseMarkConfigDialog.title = 'Sửa cấu hình'
    //   this.addCourseMarkConfigDialog.currentItem = _.cloneDeep(data)
    //   this.addCourseMarkConfigDialog.callback = (async () => {
    //     this.addCourseMarkConfigDialog.valid = this.$refs.addCourseMarkConfigDialog.validate()
    //     if (!this.addCourseMarkConfigDialog.valid) {
    //       this.$alert.error('Lỗi form! Vui lòng kiểm tra lại')
    //       return
    //     }

    //     const { id, ...data } = this.addCourseMarkConfigDialog.currentItem

    //     try {
    //       if (!this.addCourseMarkConfigDialog.currentItem) {
    //         return
    //       }
    //       await this.updateCourseMarkConfig({ id, data })
    //       this.$alert.success('Cập nhật thành công')
    //     } catch (error) {
    //       this.$alert.error('Có lỗi xảy ra')
    //       this.fetchCourseMarkConfigs(this.$route.params.id)
    //     } finally {
    //       this.addCourseMarkConfigDialog.onCancel()
    //     }
    //   }).bind(this)
    // }
  },
  created() {
    this.fetchCourse(this.$route.params.id)
    this.fetchCourseMarkConfigs(this.$route.params.id)
  },
  watch: {
    courseMarkConfigs(v) {
      // if (!this.tabIndex) {
      //   this.tabIndex = this.courseMarkConfigs.length - 1
      // }
      if (!(v || {}).length) {
        this.activeId = ''
      } else {
        if (!this.activeId || !this.courseMarkConfigs.find(i => i.id === this.activeId)) {
          this.activeId = this.courseMarkConfigs[0].id
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.select-config {
  flex: 0;
  width: 400px;
  flex-basis: auto;
}
</style>
